import { Button, Card, Checkbox, Divider } from "semantic-ui-react"
import { ReactComponent as WheelAlignment } from "../../../images/wheel-alignment.svg"
import React, { useEffect, useState } from "react"
import { withRouter } from "react-router-dom"
import { connect } from "react-redux"
import { getUpdatedCart } from "../../../v1/helpers/orderHelpers"

import WheelAlignmentCard from "./SelectService/WheelAlignmentCard"
import { WHEEL_ALIGNMENT } from "../../../v1/actions/services"
import { routerPaths } from "../../../v1/constants/paths"
import { optInForMarketing, fetchActiveCart } from "../../../v1/actions/user"

const RecommendedServices = ({
  user,
  cart,
  braintreePaymentMethods,
  history,
  optInForMarketing,
  fetchActiveCart
}) => {
  const [marketingOptIn, setMarketingOptIn] = useState(false)
  const [loading, setLoading] = useState(false)
  const hasWheelAlignment = cart.order_services.some((s) => s?.reference_id === WHEEL_ALIGNMENT)

  useEffect(() => {
    const userOptedForMarketing = user?.marketing_opt_in || false
    setMarketingOptIn(userOptedForMarketing)
  }, [])

  useEffect(() => {
    if (!hasWheelAlignment) {
      setMarketingOptIn(false)
    }
  }, [hasWheelAlignment])

  const onContinue = async () => {
    setLoading(true)
    await optInForMarketing({
      marketing_opt_in: marketingOptIn
    })
    await fetchActiveCart()

    const hasWheelAlignment = cart.order_services.some((s) => s?.reference_id === WHEEL_ALIGNMENT)

    const needsPayment = hasWheelAlignment && braintreePaymentMethods.length === 0
    setLoading(false)
    history.push({ pathname: needsPayment ? routerPaths.addPayment : routerPaths.reviewRequest })
  }

  return (
    <Card className="service-card" raised={true}>
      <div className="recommended-services">
        <WheelAlignment className="wheel-alignment" />
        <p className="title">Get Every Mile You Paid for</p>
        <WheelAlignmentCard cart={cart} />
        <Divider className="divider" />

        {user.total_shop_orders === 0 && (
          <div className="marketing-section">
            <p className="subtitle">Want to save on future maintenance?</p>
            <div className="checkbox-row">
              <Checkbox
                checked={marketingOptIn}
                onChange={() => setMarketingOptIn(!marketingOptIn)}
                className="custom-orange-checkbox"
                disabled={!hasWheelAlignment}
              />
              <p>Yes, send me exclusive discounts and receive 10% off my wheel alignment.</p>
            </div>
          </div>
        )}

        <div className="action_button">
          <Button onClick={onContinue} className="primary-button" loading={loading}>
            Continue
          </Button>
        </div>
      </div>
    </Card>
  )
}

function mapStateToProps(state, props) {
  const user = state.user || {}
  let cart
  let activeVehicle = user.vehicles && user.vehicles.find((v) => v.id === user.activeVehicleId)

  const order =
    activeVehicle &&
    activeVehicle.id &&
    (user.active_orders || []).find((o) => o.vehicle_id === activeVehicle.id)

  const updatedCartData = getUpdatedCart(user, order, props)

  if (updatedCartData) {
    cart = updatedCartData.cart
  } else {
    cart = user.active_carts && user.active_carts.find((c) => c.vehicle_id === user.activeVehicleId)
  }
  const braintreePaymentMethods = Array.isArray(state?.paymentMethods?.braintreePaymentMethods)
    ? state.paymentMethods.braintreePaymentMethods.filter((method) => method?.type !== "ach")
    : []
  return {
    cart: cart,
    braintreePaymentMethods,
    user: user
  }
}

export default withRouter(
  connect(mapStateToProps, {
    optInForMarketing,
    fetchActiveCart
  })(RecommendedServices)
)
